const paths = {
    home: '/',
    samlAuth: '/saml-callback',
    Notifications: '/notifcations',
    network: (id = ':id') => `/network/${id}`,
    messages: '/messages',
    groups: '/groups',
    post: `/post`,
    infiniteScroll: '/post/summary',
    referrals: (id = ':id') => `/referrals/${id}`,
    profileBasic: '/profile/basic',
    profileDegree: '/profile/degree',
    profileAvailability: '/profile/availability',
    profileDemographics: '/profile/demographics',
    profileSpecialties: '/profile/specialties',
    profileTreatment: '/profile/treatment-modalities',
    sessionFormat: '/profile/session-format',
    clientsServed: '/profile/client-focus',
    profileInterests: '/profile/interests',
    profileFees: '/profile/fees',
    profileLanguages: '/profile/languages',
    profileCredentials: '/profile/credentials',
    profileTraining: '/profile/training',
    profileOrganization: '/profile/organization',
    profileAccountSettings: '/profile/account-settings',
    profilePasswordSettings: '/profile/password-settings',
    profileTeam: '/profile/team',
    profileRoles: '/profile/roles',
    profilePayments: '/profile/payments',
    profileBilling: '/profile/billing',
    profileServices: '/profile/services',
    profileFaqs: '/profile/faqs',
    profileImages: '/profile/images',
    login: '/login',
    onboarding: '/onboarding',
    forgetPassword: '/forget-password',
    resetPassword: '/reset-password',
    userProfile: (id = ':id', tid = '', account_type = '') => {
        const queryParams = [];
        if (tid) queryParams.push(`tid=${tid}`);
        if (account_type) queryParams.push(`account_type=${account_type}`);
        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
        return `/user-profile/${id}/${queryString}`;
    },
    settingsAccount: '/settings/account',
    settingsPassword: '/settings/password',
    settingsInvitations: '/settings/Invitations',
    settingsNotifications: '/settings/Notifications',
    invitationOnboarding: (url = ":url") => `/teams/acceptInvite/${url}`,
    info: '/info',
    groupInfo: '/groupInfo',
    treatmentInfo: '/treatmentInfo',
    changePassword: '/change-password',
    unsubscribeEmail: '/unsubscribe-email'
};

export default paths;